<script lang="ts">
  import CloseButton from "@shared/svelte/Components/CloseButton.svelte";
  import FizzStyles from "@modern/components/shared/FizzStyles.svelte";
  export let imagePath: string = window["C"].IMAGE_PATHS["supplier-action-bar.svg"];
  export let onClose;

  let closeButtonID = "dismissActionBar";
</script>

<FizzStyles>
  <section class="fizz-inset-vertical-32 fizz-surface fizz-stack-32">
    <div
      class="fizz-surface-blue fizz-inset-square-24 fizz-radius-medium fizz-text-medium fizz-flex-row-24 fizz-relative"
    >
      <CloseButton {closeButtonID} {onClose} />
      <img
        src={imagePath}
        style="aspect-ratio: 1 / 1"
        class="fizz-hide-on-small"
        width="150"
        height="150"
        alt="svg"
      />
      <div class="fizz-flow-8">
        <h3 class="fizz-heading-3">Welcome to Your Supplier Provi Portal!</h3>
        <p>
          Manage your Provi products, preview the marketplace and access resources to help you grow
          your brand through industry insights and increase revenue with marketplace advertising.
        </p>
        <p><a href="https://www.provi.com/brands">Learn more</a></p>
      </div>
    </div>
  </section>
</FizzStyles>
